import store from ".";

export default {
  toggleDrawer() {
    const newValue = !store.getters.isDrawerMini;
    store.commit("setDrawerMini", newValue);
  },
};
